import { ref } from "vue";
import axios from "axios";
import authHeader from "@/Api/AuthHeader";

const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getAllInscriptions(data) {
      try {
        const resp = await axios.get(
          URL_API +
            `inscriptions?page=${data.page}&tipo_inscricao=todas&year=${data.year}`,
          {
            headers: authHeader(),
          }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async exportDataTopdf(year) {
      return await axios.get(
        URL_API + `exportDataTopdfInscription?year=${year}`,
        {
          headers: authHeader(),
        }
      );
    },

    async exportStudentInscriptionToPdf(year, type) {
      return await axios.get(
        URL_API +
          `exportStudentInscriptionToPdf?year=${year}&tipo_inscricao=${type}`,
        {
          headers: authHeader(),
        }
      );
    },

    async getAllInscriptionsStatistic(year) {
      const resp = await axios.get(
        URL_API + `getAllInscriptionsStatistic?year=${year}`,
        {
          headers: authHeader(),
        }
      );
      return resp;
    },

    async getPendentsInscriptions(page, year) {
      try {
        const resp = await axios.get(
          URL_API +
            `inscriptions?page=${page}&tipo_inscricao=pendentes&year=${year}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getPayedInscriptions(year) {
      try {
        const resp = await axios.get(
          URL_API + `inscriptions?tipo_inscricao=pagas&year=${year}`,
          {
            headers: authHeader(),
          }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getCandidateInscriptions(page) {
      try {
        const resp = await axios.get(
          URL_API +
            `inscriptions?page=${page.page}&tipo_inscricao=candidaturas&year=${page.year}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getConcludedInscriptions() {
      try {
        const resp = await axios.get(
          URL_API +
            `inscriptions?tipo_inscricao=renovacoes-concluidas&year=${year}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getRenewPendentsInscriptions() {
      try {
        const resp = await axios.get(
          URL_API + "inscriptions?tipo_inscricao=renovacoes-pendentes",
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },

    async aproveInscription(data, person_id) {
      return axios.post(URL_API + `change-state/${person_id}`, data, {
        headers: authHeader(),
      });
    },
  },
};
